import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import chapterImageSrc from '../../assets/images/slide/chapter-image.png';
import styles from './ProductSlideContentV2.css';

const cx = classnames.bind(styles);

const DEFAULT_STEP_OPTIONS = [
    {
        icon: 'pencil',
        title: 'She types a few lines',
        subtitle: 'whenever she has a minute'
    },
    {
        icon: 'mic',
        title: 'She presses record and talks',
        subtitle: 'we turn it into writing for her'
    }
];

const DEFAULT_CHAPTER_BULLETS = ['edited and polished', 'in her own words', 'ready to share'];

function ProductSlideContentV2({
    headingPrefix = 'Whichever she feels like.',
    headingAccent = 'It comes back the same.',
    stepOptions = DEFAULT_STEP_OPTIONS,
    chapterTitle = 'Her first chapter',
    chapterBullets = DEFAULT_CHAPTER_BULLETS
}) {
    return (
        <div className={styles.form}>
            <h2 className={styles.heading}>
                {headingPrefix} <span className={styles.highlight}>{headingAccent}</span>
            </h2>
            <div className={styles.stepsWrapper}>
                <div className={styles.optionCard}>
                    <span className={styles.stepBadge}>Step 1</span>
                    {stepOptions.map((option, index) => (
                        <React.Fragment key={option.title}>
                            {index > 0 && (
                                <div className={styles.orDivider}>
                                    <span className={styles.orDividerLine} />
                                    <span>OR</span>
                                    <span className={styles.orDividerLine} />
                                </div>
                            )}
                            <div className={styles.optionRow}>
                                <div className={styles.iconBadge}>
                                    <Icon name={option.icon} className={styles.optionIcon} />
                                </div>
                                <div className={styles.optionContent}>
                                    <p className={styles.optionTitle}>{option.title}</p>
                                    <p className={styles.optionSubtitle}>{option.subtitle}</p>
                                </div>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
                <div className={cx('optionCard', 'chapterCard')}>
                    <span className={styles.stepBadge}>Step 2</span>
                    <div className={styles.chapterRow}>
                        <div className={styles.chapterContent}>
                            <p className={styles.optionTitle}>{chapterTitle}</p>
                            <ul className={styles.chapterBullets}>
                                {chapterBullets.map(bullet => (
                                    <li key={bullet} className={styles.chapterBullet}>{bullet}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className={styles.chapterImageClip}>
                        <img src={chapterImageSrc} alt='' className={styles.chapterImage} />
                    </div>
                </div>
            </div>
        </div>
    );
}

ProductSlideContentV2.propTypes = {
    headingPrefix: PropTypes.node,
    headingAccent: PropTypes.node,
    stepOptions: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.string,
        title: PropTypes.node,
        subtitle: PropTypes.node
    })),
    chapterTitle: PropTypes.node,
    chapterBullets: PropTypes.arrayOf(PropTypes.string)
};

export {
    ProductSlideContentV2
};
